module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/neutro_hover.054f2726.svg";